import type { IErrorResponse } from '@/types/apis/Error';

import {
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import useUserActions from './useUserActions';

import urls from '@/statics/urls';

const useLikeOrDislikeLesson = ({
  lesson_id,
}: {
  lesson_id: string;
}): UseMutationResult<
  unknown,
  IErrorResponse,
  {
    action: 'like_action' | 'dislike_action';
  }
> => {
  const queryClient = useQueryClient();

  const { mutateAsync: logUserAction } = useUserActions({
    model_id: lesson_id,
    model_type: 'education_content',
  });

  return useMutation({
    mutationFn: async (data) => {
      await logUserAction(data);
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [`${urls.educationContents}/${lesson_id}`],
        }),
      ]);
    },
  });
};

export default useLikeOrDislikeLesson;
